module.exports = __webpack_public_path__ + "static/media/insta.8dc71694.jpg";